<template>
  <v-app>
      <v-container class=" mt-8">
    <v-card>
      <v-card-text class="mt-5">

        <v-alert class="alert-warn mb-10" v-if="data.status == 'pending'" border="bottom" colored-border
                 type="info" elevation="2">
          <h2>اطلاعات بیلبورد برای برسی ارسال شده است.</h2>
          <p></p>
          <p></p>
          <h4>تا زمانی که اطلاعات شما توسط مدیریت تایید نشود قادر به ویرایش اطلاعات خود
            نخواهید بود.</h4>
        </v-alert>

        <v-alert class="alert-danger mb-10" v-else-if="data.reject_text && data.status == 'reject'" border="bottom" colored-border
                 type="error" elevation="2">
          <h2>اطلاعات شما رد شده است.</h2>
          <br/>
          <h4 v-for="(x,i) in data.reject_text.split('\n')">
            {{i + 1}} : {{x}}
          </h4>
        </v-alert>

        <v-form action="#" ref="register_form">

        <v-row>
          <v-select :rules="rules.notEmpty"
                    :disabled="data.status == 'pending'" class="m-1" item-text="name" v-model="data.billboard_place" label="موقعیت بیلبورد" :items="centerItems" :loading="!centerItems.length" return-object outlined auto-select-first></v-select>
          <v-autocomplete class="m-1" v-model="data.type" :items="data.billboard_place ? data.billboard_place.types : []"
                          :rules="rules.notEmpty"
                          item-text="name" item-value="id" :disabled="!data.billboard_place || data.status == 'pending'"
                          outlined hide-no-data auto-select-first label="نوع" :error-messages="errors['type']">
          </v-autocomplete>


          <v-text-field :disabled="data.status == 'pending'" class="m-1" label="مدت اجاره (روز) " v-model="data.rental_period"
                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rental_period']" outlined>
          </v-text-field>
        </v-row>
        <v-row>
          <v-text-field :disabled="data.status == 'pending'" class="m-1" label="طول" v-model="data.dimensions[0]" :rules="rules.mosabatMokhalefSefr"
            type="number" outlined :error-messages="errors['dimensions.0']"></v-text-field>

          <v-text-field :disabled="data.status == 'pending'" class="m-1" label="عرض" v-model="data.dimensions[1]" :rules="rules.mosabatMokhalefSefr"
            type="number" :error-messages="errors['dimensions.1']" outlined></v-text-field>

          <v-text-field :disabled="data.status == 'pending'" class="m-1" label="متراژ" v-model="data.meterage" :rules="rules.mosabatMokhalefSefr"
            type="number" :error-messages="errors['meterage']" outlined></v-text-field>

        </v-row>

        <hr>



        <p class="mt-2">مبلغ اجاره : </p>
        <v-select :disabled="data.status == 'pending'" v-model="data.rentType" :items="data.rentTypes" item-text="name" item-value="value"
                  label="انتحاب نوع اجاره" :rules="rules.notEmpty" dense outlined></v-select>


        <v-row v-if="data.rentType == 'amount'" class="justify-content-center">
            <price-input v-model="data.rent[0]" :disabled="data.status == 'pending'"  :error-messages="errors['rent']"
                         label="مبلغ اجاره"

            ></price-input>

<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" style="max-width: 30rem" label="مبلغ اجاره" v-model="data.rent[0]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" append-icon="mdi-currency-rial" type="number"-->
<!--                        :error-messages="errors['rent']" outlined></v-text-field>-->
        </v-row>


        <v-row v-if="data.rentType == 'season'">
            <price-input v-model="data.rent[0]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.0']" label="بهار"></price-input>
            <price-input v-model="data.rent[1]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.1']" label="تابستان"></price-input>
            <price-input v-model="data.rent[2]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.2']" label="پاییز"></price-input>
            <price-input v-model="data.rent[3]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.3']" label="زمستان"></price-input>

<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="بهار" v-model="data.rent[0]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rent.0']" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="تابستان" v-model="data.rent[1]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.1']" type="number" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="پاییز" v-model="data.rent[2]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.2']" type="number" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="زمستان" v-model="data.rent[3]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rent.3']" outlined></v-text-field>-->

        </v-row>


        <v-row v-if="data.rentType == 'moon'">

            <price-input v-model="data.rent[0]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.0']" label="فروردین"></price-input>
            <price-input v-model="data.rent[1]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.1']" label="اردیبهشت"></price-input>
            <price-input v-model="data.rent[2]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.2']" label="خرداد"></price-input>
            <price-input v-model="data.rent[3]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.3']" label="تیر"></price-input>
            <price-input v-model="data.rent[4]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.4']" label="مرداد"></price-input>
            <price-input v-model="data.rent[5]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.5']" label="شهریور"></price-input>
            <price-input v-model="data.rent[6]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.6']" label="مهر"></price-input>
            <price-input v-model="data.rent[7]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.7']" label="آبان"></price-input>
            <price-input v-model="data.rent[8]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.8']" label="آذر"></price-input>
            <price-input v-model="data.rent[9]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.9']" label="دی"></price-input>
            <price-input v-model="data.rent[10]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.10']" label="بهمن"></price-input>
            <price-input v-model="data.rent[11]" :disabled="data.status == 'pending'"  :error-messages="errors['rent.11']" label="اسفند"></price-input>

<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="فروردین" v-model="data.rent[0]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rent.0']" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="اردیبهشت" v-model="data.rent[1]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.1']" type="number" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="خرداد" v-model="data.rent[2]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.2']" type="number" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="تیر" v-model="data.rent[3]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rent.3']" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="مرداد" v-model="data.rent[4]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" type="number" :error-messages="errors['rent.4']" outlined></v-text-field>-->



<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="شهریور" v-model="data.rent[5]"-->
<!--                        :error-messages="errors['rent.5']" :rules="rules.mosabatMokhalefSefr" type="number" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="مهر" v-model="data.rent[6]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.6']" type="number" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="آبان" v-model="data.rent[7]"-->
<!--                        :rules="rules.mosabatMokhalefSefr" :error-messages="errors['rent.7']" type="number" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="آذر" v-model="data.rent[8]"-->
<!--                        :error-messages="errors['rent.8']" :rules="rules.mosabatMokhalefSefr" type="number" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="دی" v-model="data.rent[9]"-->
<!--                        :error-messages="errors['rent.9']" :rules="rules.mosabatMokhalefSefr" type="number" outlined></v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="بهمن" v-model="data.rent[10]"-->
<!--                        :error-messages="errors['rent.10']" :rules="rules.mosabatMokhalefSefr" type="number" outlined>-->
<!--          </v-text-field>-->


<!--          <v-text-field :disabled="data.status == 'pending'"  class="m-1" append-icon="mdi-currency-rial" label="اسفند" v-model="data.rent[11]"-->
<!--                        :error-messages="errors['rent.11']" :rules="rules.mosabatMokhalefSefr" type="number" outlined>-->
<!--          </v-text-field>-->

        </v-row>

        <hr/>

        <v-row class="flex-column">
          <p class="my-3">
            عکس های بیلبورد
          </p>
          <div class="imageSelectorContainer w-100" @click="updateClick">
            <ImagePicker v-model="data.images" addImagesLabel="افزودن عکس" clearImagesLabel="حذف تمامی عکس ها" :max="10"
                         :maxSize="1000000" exceedMaxImagesError="حد اکثر تعداد عکس 10 عدد میباشد"
                         invalidFileTypeError="فرمت وارد شده باید jpeg یا jpg یا png باشد"
                         :disabled="data.status == 'pending'"
                         fileSizeError="حد اکثر حجم فایل ها 1 مگ میباشد.">
              <v-flex xs4 md3 class="justify-content-center flex-column align-items-center text-center">
                <img src="media/empty/empty-list.png" style="width:200px; height:140px">
                <p class="text-center">عکسی انتخاب کنید</p>
              </v-flex>
            </ImagePicker>
          </div>
        </v-row>
        <hr>


        <v-row v-if="false">
          <v-btn color="indigo" outlined class="text-white col-md-12 inputs my-2" :loading="video.isSelecting" :disabled="data.status == 'pending'"
                 @click="handleFileImport">
            <v-icon>mdi-briefcase-upload</v-icon>
            آپلود ویدیو
          </v-btn>
          <input ref="uploader" class="d-none" type="file" @change="onFileChanged">
          <p class="text-danger" v-if="errors['video']">{{ errors['video'] }}</p>
        </v-row>

        <v-row class="justify-content-center mt-2 mb-4" v-if="data.video_url">
          <p class="text-center mt-2 mb-4">
            فایل قبلی خود را میتوانید از
            <a target="_blank" :href="appUrl + '/storage/' + (this.data.video_url ? data.video_url : '')">
              اینجا دانلود
            </a>
            کنید
          </p>
        </v-row>




        <hr />

        <v-row class="flex-column">
          <p class="mt-2">مکان روی نقشه : </p>
          <l-map style="height: 500px" :zoom="mapData.zoom" :disabled="data.status == 'pending'"
            :center="mapData.center ? mapData.center : [32.64433, 51.65923]" :options="mapData.mapOptions"
            @click="clickedOnMap">
            <l-tile-layer :url="mapData.url" />
            <l-marker :lat-lng="data.location" v-if="data.location" />
          </l-map>
          <p class="text-danger" v-if="errors['location']">{{ errors['location'] }}</p>
          <p class="text-danger" v-if="errors['location.0']">{{ errors['location.0'] }}</p>
          <p class="text-danger" v-if="errors['location.1']">{{ errors['location.1'] }}</p>

          <v-input v-model="data.location" :rules="rules.location"></v-input>
        </v-row>

        <hr class="my-5"/>

        <v-row class="flex-column">
          <v-combobox :disabled="data.status == 'pending'"
                      class="m-1"
                      outlined
                      name="input-7-4"
                      label="آدرس"
                      :rules="rules.address"
                      v-model="data.address"
                      :items="addressSearch.items"
                      :search-input.sync="addressSearch.text"
                      :error-messages="errors['address']"></v-combobox>
          <div class="d-flex flex-column">

            <v-btn  class="btn-show" :disabled="!data.location || data.status == 'pending'" @click="selectAddressWithLocation">وارد کردن ادرس بر اساس مکان انتخابی روی نقشه</v-btn>

          </div>

        </v-row>

        <hr />

        <hr>
        <v-row>
          <v-textarea class="m-1" outlined name="input-7-4" label="توضیحات" v-model="data.description"
                      :disabled="data.status == 'pending'"
            :rules="rules.address" :error-messages="errors['description']"></v-textarea>
        </v-row>

        <v-row v-if="billId" class="justify-content-end">
          <v-btn class="btn-update" :disabled="!isValid || data.status == 'pending' || data.status == 'disable'" @click="update()" >به روز رسانی</v-btn>
        </v-row>
        <v-row v-else class="justify-content-end">
          <v-btn class="submit-btn"  @click="submit()">
            <v-icon size="25">mdi-check</v-icon>
            ثبت</v-btn>
        </v-row>
      </v-form>

      </v-card-text>
    </v-card>
      </v-container>
  </v-app>



</template>

<script>
import { latLng } from "leaflet";
import { ImagePicker, imageUploadingStates } from "@nagoos/vue-image-picker"

export default {
  name: "create",
  components: { ImagePicker, imageUploadingStates },
  data() {
    return {
      addressSearch:{
        items : [],
        text : ""
      },
      appUrl : process.env.VUE_APP_API_URL,
      data: {
        video_url: null,
        billboard_place : "",
        address: "",
        location: null,
        dimensions: [0, 0],
        images: [],
        video: null,
        meterage: 0,
        rentTypes: [
          {
            name: "توافقی",
            value: "agreement"
          }, {
            name: "مبلغ اجاره",
            value: "amount"
          }, {
            name: "تفکیک هر فصل",
            value: "season"
          }, {
            name: "تفکیک هر ماه",
            value: "moon"
          }
        ],
        rentType: "",
        rent: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
        ],
        rental_period: 0,
        description: "",
        type: 0,
      },

      mapData: {
        zoom: 13,
        center: latLng(32.64433, 51.65923),
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        currentZoom: 11.5,
        currentCenter: latLng(47.41322, -1.219482),
        mapOptions: {
          zoomSnap: 0.5
        },
      },

      video: {
        isSelecting: false,
      },

      rules: {
        text : [
            v => !!(v ?? "").trim() || "لطفا مقداری وارد کنید."
        ],
        notEmpty : [
          v => !!v || "لطفا مقداری را وارد کنید"
        ],

        location : [
          v => !!v || "لطفا موقعیت مکانی را وارد کنید"
        ],
        mosabatMokhalefSefr: [
          v => Math.sign(v) === 1 || v === 0 || "مقدار وارد شده باید عدد و بزرگتر از 0 باشد."
        ],
        address: [
          v => !((v ?? "").length < 4 || (v ?? "").length > 5000) || 'مقدار وارد شده باید بزرگتر از 4 کاراکتر و حد اکثر 5 هزار کاراکتر باشد'
        ]
      },

      typeSuggest: [],

      showSuggest: [],
      typeSearch: "",
      errors: [],
      isOkey: true,
      billId: null,
      billData: [],
      billImages: [],
      once : false,
      centerItems : []
    }

  },
  created() {


  },
  mounted() {
    this.getSuggestionType();
    window.document.querySelector(".imageSelectorContainer button.success").classList.add('submit-btn')
    window.document.querySelector(".imageSelectorContainer button.red--text").classList.add('btn-delete')
  },
  watch: {
    // "addressSearch.text"(n , v){
    //   if (n){
    //     this.requestApiPost('map/search' , {text : n})
    //         .then((res)=>{
    //           console.log(res.data.data.value.map((v) => v.address));
    //           this.addressSearch.items = res.data.data.value.map((v)=>v.address);
    //         })
    //         .catch(()=>{
    //           this.addressSearch.items = [];
    //         })
    //   }else{
    //     this.addressSearch.items = [];
    //   }
    //
    // },
    // typeSearch() {
    //   for (let i of this.typeSuggest) {
    //     if (i.name === (this.typeSearch ?? "").trim()) {
    //       this.data.type = i.id;
    //       return;
    //     }
    //   }
    //   this.showSuggest = []
    //   if (this.typeSearch) {
    //     this.showSuggest.push({
    //       name: this.typeSearch,
    //       id: this.typeSearch.trim()
    //     })
    //     this.data.type = this.showSuggest[0].id;
    //   }
    //   this.showSuggest = [...this.showSuggest, ...this.typeSuggest];
    // }
  },
  computed: {

    isValid() {
      let flag = true;
      if (this.billId) {
        flag = true
        return flag
      } else {
        flag &&= Math.sign(this.data.dimensions[0]) === 1;

        flag &&= Math.sign(this.data.dimensions[1]) === 1;

        flag &&= Math.sign(this.data.meterage) === 1;

        flag &&= Math.sign(this.data.rental_period) === 1;

        switch (this.data.rentType) {
          case "amount":
            flag &&= Math.sign(this.data.rent[0]) === 1;
            break;
          case "season":
            flag &&= Math.sign(this.data.rent[0]) === 1;
            flag &&= Math.sign(this.data.rent[1]) === 1;
            flag &&= Math.sign(this.data.rent[2]) === 1;
            flag &&= Math.sign(this.data.rent[3]) === 1;
            break;
          case "moon":
            flag &&= Math.sign(this.data.rent[0]) === 1;
            flag &&= Math.sign(this.data.rent[1]) === 1;
            flag &&= Math.sign(this.data.rent[2]) === 1;
            flag &&= Math.sign(this.data.rent[3]) === 1;
            flag &&= Math.sign(this.data.rent[4]) === 1;
            flag &&= Math.sign(this.data.rent[5]) === 1;
            flag &&= Math.sign(this.data.rent[6]) === 1;
            flag &&= Math.sign(this.data.rent[7]) === 1;
            flag &&= Math.sign(this.data.rent[8]) === 1;
            flag &&= Math.sign(this.data.rent[9]) === 1;
            flag &&= Math.sign(this.data.rent[10]) === 1;
            flag &&= Math.sign(this.data.rent[11]) === 1;
            break;
        }

        flag &&= this.isValidTextAddress(this.data.address);

        flag &&= this.isValidTextAddress(this.data.description);

        flag &&= this.isValidTextAddress(this.data.billboard_place);

        flag &&= this.data.location;

        flag &&= this.data.type;

        return flag;
      }
    },

  },
  methods: {
    fetch(){
      if (this.$route.params.id) {
        this.billId = this.$route.params.id
        this.requestApiGet('billboard/' + this.$route.params.id)
            .then(res => {
              let billData = res.data.data

              for (let i = 0; i < this.centerItems.length; i++) {
                if (this.centerItems[i].id === billData.place_id){
                  this.data.billboard_place = this.centerItems[i];
                  break;
                }
              }

              console.log("filter " , this.centerItems.filter((a) => {
                return a.id === billData.place_id;
              })[0]);


              console.log(billData.place_id)
              this.data.dimensions[0] = billData.dimensions[0]
              this.data.dimensions[1] = billData.dimensions[1]

              this.data.reject_text = billData.reject_text;
              this.data.status = billData.status;

              if (billData.meterage) {
                this.data.meterage = billData.meterage
              }

              this.data.address = billData.address
              this.data.video_url = billData.video;

              this.data.type = billData.type

              this.data.rental_period = billData.rental_period

              if (billData.location) {
                this.data.location = billData.location
                this.mapData.center = billData.location
              }

              if (billData.rent.type == 'agreement') {
                this.data.rentType = billData.rent.type
              } else if (billData.rent.type == 'amount') {
                this.data.rentType = billData.rent.type
                this.data.rent[0] = billData.rent.value
              } else if (billData.rent.type == 'season') {
                this.data.rentType = billData.rent.type
                for (let k = 0; k < billData.rent.value.length; k++) {
                  this.data.rent[k] = billData.rent.value[k]
                }
              } else if (billData.rent.type == 'moon') {
                this.data.rentType = billData.rent.type
                for (let k = 0; k < billData.rent.value.length; k++) {
                  this.data.rent[k] = billData.rent.value[k]
                }
              }


              if (billData.images) {
                for (let j = 0; j < billData.images.length; j++) {
                  this.billImages.push ({
                    imageFile: billData.images[j],
                    imageURL: process.env.VUE_APP_API_URL + '/storage/' + billData.images[j]
                  })
                  this.data.images[j] = this.billImages[j]
                }
              }
              this.data.video = billData.video
              this.data.description = billData.description



            })
            .catch(err => console.log(err))
      }
    },
    selectAddressWithLocation(){
      this.$modal.showLoading()
      this.requestApiGet('map/address' , {lat: this.data.location.lat ?? this.data.location[0] , lon: this.data.location.lng ?? this.data.location[1] })
          .then((res)=>{
            console.log(res.data.address , res.data);
            this.data.address = res.data.address;
          })
          .catch((e)=>{
            this.$toast.error('خطا در دریافت ادرس بر اساس موقعیت مکانی');
          }).finally(()=>{
            this.$modal.hideLoading();
      })
    },
    updateClick() {
      if(this.billImages.length != 0 && this.once == false) {
        this.data.images = []
        this.once = true
      }
    },
    update() {

      if (! this.$refs.register_form.validate()){
        this.$toast.error('لطفا فیلد ها را برسی کنید');
        return;
      }

      let data = new FormData();
      data.append('address', this.data.address)

      if (this.data.location.lat || this.data.location.lng) {
        data.append('location[0]', this.data.location.lat)
        data.append('location[1]', this.data.location.lng)
        console.log('lat and lang exist')
      } else {
        data.append('location[0]', this.data.location[0])
        data.append('location[1]', this.data.location[1])
        console.log('lat and lag dont exist')
      }

      data.append('meterage', this.data.meterage)

      data.append('description', this.data.description)

      data.append('type', this.data.type)

      data.append('rental_period', this.data.rental_period)

      data.append('dimensions[0]', this.data.dimensions[0])
      data.append('dimensions[1]', this.data.dimensions[1])

      data.append('billboard_place', this.data.billboard_place)


      data.append('rent[type]', this.data.rentType)

      switch (this.data.rentType) {
        case "amount":
          data.append('rent[value][0]', this.data.rent[0].toString().replace(/,/g, ''))
          break;

        case "season":
          data.append('rent[value][0]', this.data.rent[0].toString().replace(/,/g, ''))
          data.append('rent[value][1]', this.data.rent[1].toString().replace(/,/g, ''))
          data.append('rent[value][2]', this.data.rent[2].toString().replace(/,/g, ''))
          data.append('rent[value][3]', this.data.rent[3].toString().replace(/,/g, ''))
          break;

        case "moon":
          data.append('rent[value][0]', this.data.rent[0].toString().replace(/,/g, ''))
          data.append('rent[value][1]', this.data.rent[1].toString().replace(/,/g, ''))
          data.append('rent[value][2]', this.data.rent[2].toString().replace(/,/g, ''))
          data.append('rent[value][3]', this.data.rent[3].toString().replace(/,/g, ''))
          data.append('rent[value][4]', this.data.rent[4].toString().replace(/,/g, ''))
          data.append('rent[value][5]', this.data.rent[5].toString().replace(/,/g, ''))
          data.append('rent[value][6]', this.data.rent[6].toString().replace(/,/g, ''))
          data.append('rent[value][7]', this.data.rent[7].toString().replace(/,/g, ''))
          data.append('rent[value][8]', this.data.rent[8].toString().replace(/,/g, ''))
          data.append('rent[value][9]', this.data.rent[9].toString().replace(/,/g, ''))
          data.append('rent[value][10]', this.data.rent[10].toString().replace(/,/g, ''))
          data.append('rent[value][11]', this.data.rent[11].toString().replace(/,/g, ''))
          break;
      }
      console.log(this.selectedFile)
      if (this.selectedFile != undefined) {
        console.log('step 1')
        const { maxSize } = this
        let vidSize = this.selectedFile.vidSize / maxSize / maxSize
        console.log('step 2', this.selectedFile)
        if (!this.selectedFile.type.match('video.*')) {
          // check whether the upload is an video
          this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
          this.isOkey = false
        } else if (vidSize > 10) {
          // check whether the size is greater than the size limit
          this.$toast.error('حجم فایل انتخابی نباید بیش از ۱۰ مگابایت باشد.')
          this.isOkey = false
        } else {
          this.data.video = this.selectedFile
          console.log('step 3')
          data.append('video', this.data.video)
        }
      }
      console.log('step 4')
      if (this.data.images && this.data.images.length && this.data.images.key != undefined) {
        for (let img of this.data.images) {
          const { maxSize } = this
          let imgSize = img.imageFile.imgSize / maxSize / maxSize
          console.log('step 5')
          if (!img.imageFile.type.match('image.*')) {
            // check whether the upload is an image
            this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
            console.log('step 6')
          } else if (imgSize > 1) {
            // check whether the size is greater than the size limit
            this.$toast.error('حجم فایل انتخابی نباید بیش از ۱ مگابایت باشد.')
          } else {
            data.append('images[]', img.imageFile);
          }
        }
      } else if (this.data.images && this.data.images.length) {
        for (let img of this.data.images) {
          data.append('images[]', img.imageFile);
        }
      }

      if (this.isOkey == false) {
        this.$toast.error('لطفا فایل ویدیویی مناسب آپلود نمایید.')
      } else {
        this.$modal.showLoading();
        this.requestApiPost(`billboard/update/${this.billId}`, data)
          .then((res) => {
            console.log(res)
            if (res.status && res.status == 200) {
              this.goto('billboard-register')
              this.$toast.success('با موفقیت ثبت شد.')
            } else {
              this.$toast.warning('لطفا مجددا تلاش کنید')
            }
          })
          .catch((e) => {
            this.$toast.error('خطا در ثبت')
            console.log(e)
            this.errors = e.response.data.errors
          })
          .finally(() => {
            this.$modal.hideLoading();
          })
      }
    },
    submit() {

      if (! this.$refs.register_form.validate()){
        this.$toast.error('لطفا فیلد ها را برسی کنید');
        return;
      }

      let data = new FormData();
      data.append('address', this.data.address)

      data.append('location[0]', this.data.location.lat)
      data.append('location[1]', this.data.location.lng)

      data.append('meterage', this.data.meterage)

      data.append('description', this.data.description)

      data.append('type', this.data.type)

      data.append('rental_period', this.data.rental_period)

      data.append('dimensions[0]', this.data.dimensions[0])
      data.append('dimensions[1]', this.data.dimensions[1])

      data.append('billboard_place', this.data.billboard_place)

      data.append('rent[type]', this.data.rentType)

      switch (this.data.rentType) {
        case "amount":
          data.append('rent[value][0]', this.data.rent[0].toString().replace(/,/g, ''))
          break;

        case "season":
          data.append('rent[value][0]', this.data.rent[0].toString().replace(/,/g, ''))
          data.append('rent[value][1]', this.data.rent[1].toString().replace(/,/g, ''))
          data.append('rent[value][2]', this.data.rent[2].toString().replace(/,/g, ''))
          data.append('rent[value][3]', this.data.rent[3].toString().replace(/,/g, ''))
          break;

        case "moon":
            data.append('rent[value][0]', this.data.rent[0].toString().replace(/,/g, ''))
            data.append('rent[value][1]', this.data.rent[1].toString().replace(/,/g, ''))
            data.append('rent[value][2]', this.data.rent[2].toString().replace(/,/g, ''))
            data.append('rent[value][3]', this.data.rent[3].toString().replace(/,/g, ''))
            data.append('rent[value][4]', this.data.rent[4].toString().replace(/,/g, ''))
            data.append('rent[value][5]', this.data.rent[5].toString().replace(/,/g, ''))
            data.append('rent[value][6]', this.data.rent[6].toString().replace(/,/g, ''))
            data.append('rent[value][7]', this.data.rent[7].toString().replace(/,/g, ''))
            data.append('rent[value][8]', this.data.rent[8].toString().replace(/,/g, ''))
            data.append('rent[value][9]', this.data.rent[9].toString().replace(/,/g, ''))
            data.append('rent[value][10]', this.data.rent[10].toString().replace(/,/g, ''))
            data.append('rent[value][11]', this.data.rent[11].toString().replace(/,/g, ''))
          break;
      }

      if (this.selectedFile) {
        const { maxSize } = this
        let vidSize = this.selectedFile.vidSize / maxSize / maxSize
        if (!this.selectedFile.type.match('video.*')) {
          // check whether the upload is an video
          this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
          this.isOkey = false
        } else if (vidSize > 10) {
          // check whether the size is greater than the size limit
          this.$toast.error('حجم فایل انتخابی نباید بیش از ۱۰ مگابایت باشد.')
          this.isOkey = false
        } else {
          this.data.video = this.selectedFile
          data.append('video', this.data.video)
        }
      }

      if (this.data.images && this.data.images.length) {
        console.log(this.data.images)
        for (let img of this.data.images) {
          const { maxSize } = this
          let imgSize = img.imageFile.imgSize / maxSize / maxSize
          if (!img.imageFile.type.match('image.*')) {
            // check whether the upload is an image
            this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
          } else if (imgSize > 1) {
            // check whether the size is greater than the size limit
            this.$toast.error('حجم فایل انتخابی نباید بیش از ۱ مگابایت باشد.')
          } else {
            data.append('images[]', img.imageFile);
          }
        }
      }

      if (this.isOkey == false) {
        this.$toast.error('لطفا فایل ویدیویی مناسب آپلود نمایید.')
      } else {
        this.$modal.showLoading();
        this.requestApiPost('billboard', data)
          .then((res) => {
            this.goto('billboard-register')
            this.$toast.success('با موفقیت ثبت شد.')
          })
          .catch((e) => {
            console.log(e)
            this.errors = e.response.errors
            this.$toast.error('خطا در ثبت')
          })
          .finally(() => {
            this.$modal.hideLoading();
          })
      }

    },
    isValidTextAddress(v) {
      return !((v ?? "").length < 4 || (v ?? "").length > 5000)
    },
    clickedOnMap(e) {
      this.data.location = e.latlng;
      console.log(this.data.location)
    },
    getSuggestionType() {
      this.requestApiGet('places?withType=1')
        .then((res) => {
          this.centerItems = res.data.data;
          this.fetch();
        })
    },
    handleFileImport() {
      this.video.isSelecting = true;
      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener('focus', () => {
        this.video.isSelecting = false
      }, { once: true });
      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      const { maxSize } = this
      this.selectedFile = e.target.files[0];
      // Do whatever you need with the file, liek reading it with FileReader
      let size = this.selectedFile.size / maxSize / maxSize
      console.log('video 1')
      console.log(this.selectedFile, '2')
      if (!this.selectedFile.type.match('video.*')) {
        // check whether the upload is an image
        this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
        console.log('video 2')
      } else if (size > 10) {
        // check whether the size is greater than the size limit
        this.$toast.error('حجم فایل انتخابی نباید بیش از ۱۰ مگابایت باشد.')
      }
    },

  }
}
</script>

<style>
.imageSelectorContainer .layout {
  justify-content: center !important;
}

.imageSelectorContainer button.success{
  height: 3rem;
  background-color: transparent !important;
}

.imageSelectorContainer button.success:hover{
  color: white !important;
}

.imageSelectorContainer button.red--text{
  height: 3rem;
}

.imageSelectorContainer button.red--text:hover{
  color: white !important;
}
</style>
